module.exports = __webpack_public_path__ + "media/images/soar/site/woman_04-af4efcd7c1181312f3579b9e3206cfd6.svg";